module.exports = __webpack_public_path__ + "media/87.5f95e25f.wav";